import {flow, get, map} from 'lodash/fp';

import {FETCH_INITIAL_DATA} from '/enum/launchSequence.enum';
import {
  getPerformance,
  getRankProgression,
  getSameDayLastMonth,
} from '/redux/action/coach.action';
import {getTeams} from '/redux/action/coach.action';
import {
  getClientMetrics,
  getHomeMetrics,
  getTeamsMetrics,
} from '/redux/action/metric.action';
import {nextRankIdById} from '/redux/selector/coach.selector';
import {isSignedIn, userId} from '/redux/selector/currentUser.selector';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {
  getActiveRoutes as getActiveNavigationRoutes,
  readState as readNavigationState,
} from '/util/navigation.util';
import {withProps} from '/util/selector.util';

const mainScreenRegexp = new RegExp('content-with-drawer\\.([^.]+)$');

const fetchInitialDataTask = {
  stepName: FETCH_INITIAL_DATA,
  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    withProps({stepName: FETCH_INITIAL_DATA})(completedStepByName)(state),
  perform: ({dispatch, state}: any) => {
    if (isSignedIn(state)) {
      // @ts-expect-error TS(2345): Argument of type '(navigationState: any) => Promis... Remove this comment to see the full error message
      return readNavigationState().then(navigationState => {
        const activeRoutes = flow([
          getActiveNavigationRoutes,
          map(get('name')),
        ])(navigationState);

        const matchResult = activeRoutes.join('.').match(mainScreenRegexp);
        const screenName = get(1, matchResult);
        const coachId = userId(state);

        if (screenName === 'dashboard') {
          return Promise.all([
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
            dispatch(getHomeMetrics()),
            dispatch(getSameDayLastMonth({coachId})),
          ]);
        } else if (screenName === 'performance') {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          const nextRankId = withProps({coachId})(nextRankIdById)(state);

          return Promise.all([
            dispatch(getPerformance({coachId})),
            dispatch(getRankProgression({coachId, rankId: nextRankId})),
          ]);
        } else if (screenName === 'teams') {
          return Promise.all([
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
            dispatch(getTeamsMetrics()),
            dispatch(getSameDayLastMonth({coachId})),
          ]);
        } else if (screenName === 'clients') {
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          return Promise.all([dispatch(getClientMetrics())]);
        } else if (screenName === 'profile') {
          return Promise.all([dispatch(getTeams({coachId}))]);
        }
      });
    } else {
      return Promise.resolve();
    }
  },
};

export default fetchInitialDataTask;
